import React, { PureComponent } from 'react';
import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;
const transitionTime = '300ms';
const spinnerColor = '#1573a5';
// This was a fontawesome spinner but because that spinner was a paid tool we had to 
// do SOMETHING to keep the application working. This is the fastest path to
// something ugly but working.
const ClickMask = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

const AnimatedSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-30px, -30px);
  font-size: 60px;
  z-index: 2;
  transform-origin: center;
  @media ${DEVICE.MOBILE} {
    font-size: 40px;
    transform: translate(-20px, -20px);
  }
  svg {
    transform-origin: center;
  }
  svg path {
    fill: ${({ color }) => color};
  }
`;


const rota360 = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const SpinnerDiv = styled.div`
  position: relative;
  transform: translateZ(0);
  animation: ${rota360} 1.4s infinite linear;
  margin: auto;
  border-radius: 50%;
  width: 65px;
  height: 65px;
  font-size: 10px;
  text-indent: -9999em;
  background: ${spinnerColor};
  background: linear-gradient(
    to right,
    ${spinnerColor} 0%,
    ${({ theme }) => theme.colors.white}
  );
  opacity: 0;
  transition: ${transitionTime};
  visibility: hidden;

  &:before {
    position: absolute;
    top: 0;
    left: 50%;
    border-radius: 0 100% 0 0;
    width: 50%;
    height: 50%;
    background: ${({ theme }) => theme.colors.white};
    content: '';
  }
  &:after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    width: 75%;
    height: 75%;
    background: ${({ theme }) => theme.colors.white};
    content: '';
  }

  ${({ show }) => css`
    opacity: 1;
    visibility: visible;
  `}
`;

export class Spinner extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
  };

  static defaultProps = {
    color: 'white',
  };

  render() {
    const { color } = this.props;

    return (
      <ClickMask>
        <AnimatedSpinner color={color}>
          <SpinnerDiv />
        </AnimatedSpinner>
      </ClickMask>
    );
  }
}
export default Spinner;
